import { Tags } from '../constants/tags.enum';
import { CLOCK } from '../controllers/util-level/clock.controller';
import { useProps, useStore } from '../utils/mobx.utils';
import { supportGroupHasAvailability } from "../utils/supportGroup.helpers";
import { createMomentFn } from '../utils/time.utils';
import { isFunction } from '../utils/typeChecks.utils';
export function useSupportGroupGetters(supportGroup, timezoneMode) {
    var _createMoment = createMomentFn(timezoneMode !== null && timezoneMode !== void 0 ? timezoneMode : 'auto');
    var p = useProps({ supportGroup: supportGroup });
    var s = useStore(function () { return ({
        get supportGroup() {
            return isFunction(p.supportGroup) ? p.supportGroup() : p.supportGroup;
        },
        get sg() {
            return s.supportGroup;
        },
        get topic() {
            var _a, _b;
            return ((_b = (_a = s.sg) === null || _a === void 0 ? void 0 : _a.topic) === null || _b === void 0 ? void 0 : _b.displayName) || 'No topic';
        },
        get title() {
            var _a;
            return ((_a = s.sg) === null || _a === void 0 ? void 0 : _a.title) || 'Support Group';
        },
        get description() {
            var _a;
            return ((_a = s.sg) === null || _a === void 0 ? void 0 : _a.description) || 'This Support Group has no description.';
        },
        get facilitatorId() {
            var _a, _b, _c;
            return ((_a = s.sg) === null || _a === void 0 ? void 0 : _a.facilitatorId) || ((_c = (_b = s.sg) === null || _b === void 0 ? void 0 : _b.facilitator) === null || _c === void 0 ? void 0 : _c.id);
        },
        get scheduledStartTime() {
            var _a;
            return (_a = s.sg) === null || _a === void 0 ? void 0 : _a.timeScheduled;
        },
        get scheduledDuration() {
            var _a;
            return ((_a = s.sg) === null || _a === void 0 ? void 0 : _a.scheduledDurationInMinutes) || 60;
        },
        get scheduledEndTime() {
            var _a;
            return _createMoment((_a = s.sg) === null || _a === void 0 ? void 0 : _a.timeScheduled).add(s.scheduledDuration, 'minutes');
        },
        get startTime() {
            var _a;
            return (_a = s.sg) === null || _a === void 0 ? void 0 : _a.timeStarted;
        },
        get endTime() {
            var _a;
            return (_a = s.sg) === null || _a === void 0 ? void 0 : _a.timeEnded;
        },
        get isInThePast() {
            var time = s.scheduledStartTime;
            if (!time)
                return false;
            return _createMoment(time).isBefore(CLOCK.localNowMoment);
        },
        get hasJoined() {
            var _a;
            return Boolean((_a = s.sg) === null || _a === void 0 ? void 0 : _a.currentUserHasRegistered);
        },
        get hasStarted() {
            return Boolean(s.startTime);
        },
        get hasEnded() {
            return Boolean(s.endTime);
        },
        get isLive() {
            return Boolean(s.hasStarted && !s.hasEnded);
        },
        get numJoined() {
            var _a, _b;
            return (_b = (_a = s.sg) === null || _a === void 0 ? void 0 : _a.reservationCount) !== null && _b !== void 0 ? _b : 0;
        },
        get max() {
            var _a;
            return (_a = s.sg) === null || _a === void 0 ? void 0 : _a.maxParticipants;
        },
        get isEmpty() {
            return s.numJoined === 0;
        },
        get numAvailable() {
            return s.max ? (s.max - s.numJoined) : Infinity;
        },
        get hasAvailability() {
            return s.sg && supportGroupHasAvailability(s.sg);
        },
        get almostFull() {
            return !s.isFull && s.numAvailable <= 5;
        },
        get isFull() {
            return !s.hasAvailability;
        },
        get isArchived() {
            var _a;
            return Boolean((_a = s.sg) === null || _a === void 0 ? void 0 : _a.timeArchived);
        },
        get isForFrontLineWorkers() {
            var _a, _b;
            return (_b = (_a = s.sg) === null || _a === void 0 ? void 0 : _a.tags) === null || _b === void 0 ? void 0 : _b.includes(Tags.FrontLineWorkers);
        }
    }); });
    return s;
}
